const disputeClaimsIT = {
    "view": {
        "table": {
            "title": "Le tue violazioni del copyright",
            "columns": {
                "release": "Rilascio",
                "user": "Utente",
                "store": "Negozio",
                "claimantName": "Nome del richiedente",
                "claimantEmail": "Email del richiedente",
                "resolutionTime": "Tempo di risoluzione",
                "remainingTime": "Tempo rimanente",
                "status": "Stato"
            },
            "label": {
                "status_created": "Creato",
                "status_pending": "In sospeso",
                "status_in_progress": "In corso",
                "status_resolved": "Risolto",
                "status_copyright_violation": "Violazione del copyright"
            },
            "button": {
                "exportCSV": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            }
        }
    }
};

export default disputeClaimsIT;